const faq = () => {
    (function () {
        try {
            const cards = document.querySelectorAll('.faq__card'),
                blocks = document.querySelectorAll('.faq__item');

            let activeCard = document.querySelector('.faq__card.active'),
                activeBlock = document.querySelector('.faq__item.active');

            cards.forEach((card, i) => {
                card.addEventListener('click', () => {
                    activeCard.classList.remove('active');
                    activeBlock.classList.remove('active');
                    card.classList.add('active');
                    blocks[i].classList.add('active');
                    activeCard = card;
                    activeBlock = blocks[i];
                })
            })
        } catch(e) {
            console.log(e);
        }
    }());
}

export default faq;